/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-08-31 09:55:36
 * @Description:
 * @LastEditors: Please set LastEditors
 */
import dhServer from './dhServer'
import _ from 'lodash'
import ApiMixinSystem from '@/assets/js/api/systemParams'
const errorHandle = async (err, status) => {
  const errInfo = err.response
  if (status === 404) {
    return app.$message.error('请求的资源不存在')
  }
  return app.$message.error(err.message)
}
const getPublicKey = async () => {
  const res = await dhServer.getPublicKey()
  if (res && res.code === '0' && res.data) {
    return res.data.publicKey
  } else {
    return ''
  }
}
const getSystemParams = async () => {
  const systemParamsRes = await ApiMixinSystem.methods.apiSystemParams({
    method: 'getSystem',
    params: {
      dataPage: {
        pageSize: 999,
      },
    },
  })
  if (systemParamsRes && systemParamsRes.success && systemParamsRes.dataList) {
    const systemParams = systemParamsRes.dataList
    const DHBaseInfo =
      _.find(systemParams, {
        parameterCode: 'DHBaseInfo',
      }) || {}
    return DHBaseInfo.parameterValue
  } else {
    return {}
  }
}
const userKeepAlive = async (magicId) => {
  const res = await dhServer.userKeepAlive({
    magicId,
    clientType: 1,
  })
  if (res && res.code === '0') {
    return true
  }
  return false
}
const errorAPI = async (res, data) => {
  const errConfig = res.config
  if (data.code === '27001007') {
    // 获取系统参数
    let DHBaseInfo = await getSystemParams()
    if (_.isEmpty(DHBaseInfo)) {
      return app.$message.error('请在系统参数中配置大华的基本信息!')
    }
    DHBaseInfo = JSON.parse(DHBaseInfo)
    const rsa = new JSEncrypt()
    // 执行登录操作
    const public_key = await getPublicKey()
    rsa.setPublicKey(public_key)
    const query = {
      grant_type: 'password',
      username: DHBaseInfo.username,
      password: rsa.encrypt(DHBaseInfo.password),
      client_id: DHBaseInfo['client_id'],
      client_secret: DHBaseInfo['client_secret'],
      public_key: public_key,
    }
    const loginRes = await dhServer.oauthSystem(query)
    if (loginRes && loginRes.code === '0' && loginRes.data) {
      const resData = loginRes.data
      localforage.setItem('DHAccessToken', resData.token_type + ' ' + resData.access_token)
      localforage.setItem('DHRefreshToken', resData.refresh_token)
      const bool = await userKeepAlive(resData.magicId)
      if (!bool) {
        return app.$message.error('登录大华系统失败!')
      } else {
        const DHRefreshToken = await LocalForage.getItem('DHRefreshToken')
        const refreshTokenRes = await dhServer.refreshToken({
          grant_type: 'refresh_token',
          client_id: DHBaseInfo['client_id'],
          client_secret: DHBaseInfo['client_secret'],
          refresh_token: DHRefreshToken,
        })
        if (refreshTokenRes && refreshTokenRes.code === '0' && refreshTokenRes.data) {
          localforage.setItem(
            'DHAccessToken',
            refreshTokenRes.data.token_type + ' ' + refreshTokenRes.data.access_token
          )
          localforage.setItem('DHRefreshToken', refreshTokenRes.data.refresh_token)
        } else {
          return app.$message.error('登录大华系统失败!')
        }
      }
    } else {
      return app.$message.error('登录大华系统失败!')
    }
    let againRes = null
    const DHAccessToken = await LocalForage.getItem('DHAccessToken')
    const instance = axios.create()
    instance.defaults.headers = {
      Authorization: DHAccessToken,
      'User-Id': 1,
      'Content-Type': errConfig.headers['Content-Type'],
    }
    if (errConfig && errConfig.method === 'get') {
      const newRes = await instance.get(errConfig.url)
      if (newRes && newRes.data) {
        againRes = newRes.data
      } else {
        return app.$message.error('登录大华系统失败!')
      }
    } else if (errConfig && errConfig.method === 'post') {
      const newRes = await instance.post(errConfig.url, errConfig.data)
      if (newRes && newRes.data) {
        againRes = newRes.data
      } else {
        return app.$message.error('登录大华系统失败!')
      }
    } else if (errConfig && errConfig.method === 'patch') {
      const newRes = await instance.patch(errConfig.url, errConfig.data)
      if (newRes && newRes.data) {
        againRes = newRes.data
      } else {
        return app.$message.error('登录大华系统失败!')
      }
    }
    return againRes
  }
}
export default (err, res) => {
  if (err) {
    const info = JSON.parse(JSON.stringify(err))
    if (info && info.response) {
      return errorHandle(err, info.response.status)
    } else {
      return
    }
  }
  if (res.data.success || res.data.desc === 'Success') {
    return {
      code: res.data.code,
      data: res.data.data,
      message: res.data.desc,
    }
  } else {
    return errorAPI(res, res.data)
  }
  return res.data
}
